/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.1.0
 * @since 1.0.1
 *
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL,
    LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST,
    LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS,
    WIDGET_SUBSCRIBER_MOBILE_REDIRECT,
} from './widgetSubscriberMobileConstants';
import {
    IWidgetSubscriberMobileSuccessProps,
    TLoadSubscribersStatusesFailAction,
    TLoadSubscribersStatusesRequestAction,
    TLoadSubscribersStatusesSuccessAction,
    TWidgetSubscribersMobileRedirectAction,
} from './widgetSubscriberMobileTypes';

/*
* -------------------------------------------
*        LOAD DATA FOR WIDGET SUBSCRIBER MOBILE
* -------------------------------------------
*/

export const widgetSubscriberMobileRequest = (): TLoadSubscribersStatusesRequestAction =>
    createAction(LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST);

export const widgetSubscriberMobileSuccess =
    (payload: IWidgetSubscriberMobileSuccessProps): TLoadSubscribersStatusesSuccessAction =>
        createAction(LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS, payload);

export const widgetSubscriberMobileFail = (payload: string): TLoadSubscribersStatusesFailAction =>
    createAction(LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL, payload);

export const widgetSubscriberMobileRedirect = (payload: string): TWidgetSubscribersMobileRedirectAction =>
    createAction(WIDGET_SUBSCRIBER_MOBILE_REDIRECT, payload);
